<template>
  <div>
     <!-- 申请测试 -->
    <el-dialog
      title="Apply for Test"
      :visible="applyDialogVisible"
      width="565px"
      class="applyDialog"
      center
      @close="closeApplyforTestVisible"
    >
      <el-form :model="applyfortestForm" label-position="top" >
        <el-form-item label="App Key">
          <el-input
            disabled
            v-model="applyfortestForm.appKey"
            style="width: 400px"
            placeholder="client 4760"
          /><el-button type="text" class="copybtn" @click="getAPPKey"
            ><img
              src="../../../assets/images/dataServices/dataapi-img/copybtn.svg"
              alt=""
            />Copy</el-button
          >
        </el-form-item>
        <el-form-item label="Secret Key">
          <el-input
            disabled
            v-model="applyfortestForm.secretKey"
            style="width: 400px"
            placeholder="9zH^!6rj6j!BGuto"
          /><el-button type="text" class="copybtn" @click="getSecretKey"
            ><img
              src="../../../assets/images/dataServices/dataapi-img/copybtn.svg"
              alt=""
            />Copy</el-button
          >
        </el-form-item>
        <el-form-item label="Application date">
          <el-date-picker
            disabled
            style="width: 100%"
            v-model="applyfortestForm.createTime"
            type="datetime"
            value-format="yyyy-MM-dd hh:mm:ss"
            placeholder="select"
          >
          </el-date-picker>
        </el-form-item>
        <div class="flex-box">
          <el-form-item label="Validity period">
          <el-input 
            disabled
            v-model="applyfortestForm.days" placeholder="30 days" />
        </el-form-item>
        <el-form-item label="Number of calls">
          <el-input
            disabled
            v-model="applyfortestForm.callCount"
            placeholder="1,000 times"
          />
        </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toGenerateClick()" class="GenerateBtn"
          >Generate</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['applyDialogVisible','applyfortestForm'],
  data () {
    return {
    }
  },
  components: {},
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    getAPPKey(){
        this.$emit('getAPPKey')
    },
    getSecretKey(){
        this.$emit('getSecretKey')
    },
    toGenerateClick(){
        this.$emit('toGenerateClick')
    },
    closeApplyforTestVisible(){
        this.$emit('closeApplyforTestVisible')
    }
  }
}
</script>

<style scoped>
.applyDialog /deep/ .el-dialog{
  border-radius:30px;
}
.applyDialog /deep/.el-dialog__body {
  border-radius: none !important;
  box-shadow: none !important;
  padding:30px 30px 8px 30px;
}
.applyDialog /deep/ .el-input__inner {
  height: 42px !important;
  line-height: 42px !important;
}
.applyDialog /deep/ .el-dialog__header {
  padding: 26px 0 0 0;
}
.applyDialog /deep/ .el-dialog__header .el-dialog__title {
  font-size: 20px;
  color: #1a2332;
}
.applyDialog /deep/ .copybtn {
  background: #faf1ec;
  font-size: 16px;
  color: #b98b73;
  text-align: center;
  padding: 11px 10px;
  border-radius: 10px;
  margin-left: 16px;
}
.applyDialog /deep/ .copybtn img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  vertical-align: middle;
}
.applyDialog /deep/ .el-form-item__label {
  padding: 0 !important;
  color: #1a2332;
  font-size: 16px;
}
/* 标准写法（现代浏览器） */
.applyDialog /deep/ input::placeholder {
  color: #999999;
  opacity: 1; /* 某些浏览器默认 opacity < 1 */
}
.applyDialog /deep/ .el-button.el-button--primary {
  width: 250px;
  height: 40px;
  font-size: 16px;
  color: #fff;
}
.applyDialog /deep/ .el-dialog__footer {
  padding:0 30px 54px 30px;
}
.applyDialog /deep/ .dialog-footer .GenerateBtn{
  width:100%;
}
.flex-box{
  display: flex;
  justify-content: space-between;
  gap:20px;
}
.applyDialog .flex-box /deep/ .el-form-item{
  width:100%;
}
.applyDialog /deep/ .el-input__icon{
  font-size:16px;
}
/* 大版本及中版本：media的范围（1920px至1440px）; */
@media (max-width: 1920px) {
  /* 字体 标题改成20px */
  /* 字体 内容改成16px 包括按钮里字体*/
  /* 圆角 改成10px */
  /* padding *0.75 */
  /* 弹框的宽度*0.75 */
  /* .applyDialog /deep/ .el-dialog{
  width:424px!important;
} */
}
/* 小版本：media的范围（1440px以下）; */
@media (max-width: 1440px) {
  /* 字体 标题改成18px */
  /* 字体 内容改成14px 包括按钮里字体*/
  /* 圆角 改成8px */
  /* padding *0.67 */
  /* 弹框的宽度*0.67 */
    /* .applyDialog /deep/ .el-dialog{
  width:378px!important;
} */
}
</style>
